import { useEffect } from "react";

import { reloadScript } from "../utils/ScriptUtil";

import { useLocation } from "react-router-dom";

const LINKEDIN_INSIGHT_ID = process.env.REACT_APP_LINKEDIN_INSIGHT_ID;

export const useLinkedinInsight = () => {
    const location = useLocation();
  
    useEffect(() => {
      window._linkedin_data_partner_id = LINKEDIN_INSIGHT_ID;
    }, []);

    useEffect(() => {
      window._bizo_main_already_called = false;
      window._already_called_lintrk = false;
      reloadScript("linkedin-insight", "https://snap.licdn.com/li.lms-analytics/insight.min.js", true);
    }, [location.pathname]);
};
